import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.nickname || user.name}!`);
      navigate(user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5 py-12">
      <form onSubmit={submit} className="w-full max-w-md card-warm rounded-3xl p-8" data-testid="login-form">
        <div className="text-center mb-6">
          <Logo className="h-20 mx-auto mb-3" />
          <h1 className="headline text-3xl text-[#f7f3ec]">Member Login</h1>
          <p className="text-[#a9a196] text-sm">Access your Ryder portal</p>
        </div>
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email" className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 mb-3 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid="login-email" />
        <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Password" className="w-full bg-[#1a1816] border border-[#3a332c] rounded-xl px-4 py-3 mb-5 text-[#f7f3ec] placeholder:text-[#6b645b] focus:border-[#e0481f] outline-none" data-testid="login-password" />
        <button disabled={loading} className="w-full btn-ember rounded-full py-3.5 font-display uppercase tracking-wider flex items-center justify-center gap-2 disabled:opacity-60" data-testid="login-submit">
          {loading ? <Loader2 className="animate-spin" size={18} /> : null} Log In
        </button>
        <p className="text-center text-sm text-[#a9a196] mt-4"><Link to="/forgot-password" className="text-[#f3c649]" data-testid="login-forgot-link">Forgot password?</Link></p>
        <p className="text-center text-sm text-[#a9a196] mt-5">Got a member code? <Link to="/register" className="text-[#f3c649]">Create your account</Link></p>
        <p className="text-center text-sm text-[#a9a196] mt-1">Not a member yet? <Link to="/join" className="text-[#f3c649]">Apply to join</Link></p>
      </form>
    </div>
  );
}
